import { Component } from '@angular/core';
import { AgencyService } from '../../../common-theme/api/agency.service';
import { LocaleAwareBaseComponent } from './../../../common-theme/seo/locale-aware-base.component';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})

export class FooterComponent extends LocaleAwareBaseComponent {
  constructor(
    public agencyService: AgencyService
  ) {
    super();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/footer/footer.component.ts